import Cancellation from './cancellation'
import DateTimePicker from './datetime-picker'
import DriverNotes from './driver-notes'
import FlightInfo from './flight-info'
import GuestInformation from './guest-information'
import LocationInput from './location-input'
import Reservation from './reservation'
import ServiceSelection from './service-selection'
import UnassignDriver from './unassign-driver'
import Update from './update'

export default {
  strict: true,
  namespaced: true,
  state: Object.assign(
    Cancellation.state,
    DateTimePicker.state,
    DriverNotes.state,
    FlightInfo.state,
    GuestInformation.state,
    LocationInput.state,
    Reservation.state,
    ServiceSelection.state,
    UnassignDriver.state,
    Update.state
  ),
  mutations: Object.assign(
    Cancellation.mutations,
    DateTimePicker.mutations,
    DriverNotes.mutations,
    FlightInfo.mutations,
    GuestInformation.mutations,
    LocationInput.mutations,
    Reservation.mutations,
    ServiceSelection.mutations,
    UnassignDriver.mutations,
    Update.mutations
  )
}



// WEBPACK FOOTER //
// ./src/store/rsvp-edit/index.js